<template>
    <div class="relative">
        <!-- Dropdown button -->
        <div class="flex items-center w-20" @click="toggleDropdown">
            <button
                class="py-0 pl-0 mb-0 focus:ring-0 border-none bg-transparent flex-1 cursor-pointer focus:outline-none">
                <span :class="'flag-icon flag-icon-' + flagForLocale(locale)" class="mr-2"></span>
                <span class="text-sm md:text-base">{{ locale.toUpperCase() }}</span>
            </button>
            <Icon class="cursor-pointer" name="mdi:chevron-down"></Icon>
        </div>
        <!-- Custom Dropdown -->
        <div v-if="isDropdownOpen" class="absolute rounded bg-white border border-gray-300 mt-2 z-10 w-20">
            <ul>
                <li v-for="l in availableLocales" :key="l" @click="changeLocale(l)"
                    class="flex items-center cursor-pointer px-2 py-1 hover:bg-gray-100">
                    <span :class="'flag-icon flag-icon-' + flagForLocale(l)" class="mr-2"></span>
                    <span class="text-sm md:text-base">{{ l.toUpperCase() }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const { locale, locales, setLocale, availableLocales } = useI18n()
const isDropdownOpen = ref(false);

const toggleDropdown = () => {
    isDropdownOpen.value = !isDropdownOpen.value;
};

// Change locale
const changeLocale = (newLocale) => {
    setLocale(newLocale);
    isDropdownOpen.value = false;
    // Additional logic to switch the locale in your application (e.g. i18n)
};

const flagForLocale = (locale) => {
  if (locale === 'en') {
    return 'gb'; // You can also use 'us' if you prefer the US flag
  }
  return locale;
};
</script>
